<!-- components/forbidden-keyword-actions-column.vue -->
<template>
    <div class="d-flex d-inline">
        <div class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i @click="editKeyword" class="fa fa-edit text-primary" title="ویرایش"></i>
        </div>
        <div class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i @click="deleteKeyword" class="fa fa-trash text-danger" title="حذف"></i>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {i18n} from '@/plugins/i18n'
import toastr from 'toastr'
import axios from 'axios'
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from '@/common/jwt.service'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        statusIconClass() {
            return this.row.status == 1 
                ? 'fa-toggle-on text-success' 
                : 'fa-toggle-off text-secondary'
        },
        statusTitle() {
            return this.row.status == 1 
                ? i18n.t('forbidden_keywords.deactivate') 
                : i18n.t('forbidden_keywords.activate')
        }
    },
    methods: {
        editKeyword() {
            if (typeof window.editForbiddenKeyword === 'function') {
                window.editForbiddenKeyword(this.row)
            }
        },
        deleteKeyword() {
            if (typeof window.deleteForbiddenKeyword === 'function') {
                window.deleteForbiddenKeyword(this.row.id)
            }
        },
    },
})
</script>

<style>
.btn-icon-sm i {
    cursor: pointer;
    font-size: 16px;
    padding: 5px;
}

.btn-icon-sm i:hover {
    transform: scale(1.1);
    transition: transform 0.2s;
}
</style>